import request from '@/utils/request'
const BASE_URL = '/ali/orders'

export default {
  sync(data) {
    return request({
      url: BASE_URL + '/sync',
      method: 'post',
      data
    })
  },
  syncStatus() {
    return request({
      url: BASE_URL + '/syncstatus',
      method: 'get',
    })
  },
  syncLogistics() {
    return request({
      url: BASE_URL + '/synclogistics',
      method: 'post',
    })
  },
  syncLogisticsStatus() {
    return request({
      url: BASE_URL + '/synclogisticsstatus',
      method: 'get',
    })
  },
  getCategories() {
    return request({
      url: BASE_URL + '/categories',
      method: 'get',
    })
  },
  getCountInfo() {
    return request({
      url: BASE_URL + '/countinfo',
      method: 'get',
    })
  },
  getOrders(params) {
    return request({
      url: BASE_URL,
      method: 'get',
      params
    })
  },
  send(data) {
    return request({
      url: BASE_URL + '/send',
      method: 'post',
      data
    })
  },
  updateAfterSend(data) {
    return request({
      url: BASE_URL + '/updateaftersend',
      method: 'post',
      data
    })
  },
  saveFlag(data) {
    return request({
      url: BASE_URL + '/saveflag',
      method: 'post',
      data
    })
  },
  saveLock(data) {
    return request({
      url: BASE_URL + '/savelock',
      method: 'post',
      data
    })
  },
  fileImportUrl: "/api" + BASE_URL + "/import",
  decrypt(orderSns, token = null) {
    if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    return request({
      url: BASE_URL + '/decrypt',
      method: 'post',
      data: { orderSns }
    })
  },
  modifyOrderPrice(data) {
    return request({
      url: BASE_URL + '/modifyorderprice',
      method: 'post',
      data
    })
  },
  batchSubmitRate(data) {
    return request({
      url: BASE_URL + '/batchsubmitrate',
      method: 'post',
      data
    })
  },
  postponeConfirmTime(data) {
    return request({
      url: BASE_URL + '/postponeconfirmtime',
      method: 'post',
      data
    })
  },
  print(data) {
    return request({
      url: BASE_URL + '/print',
      method: 'post',
      data,
    })
  },
  test() {
    return request({
      url: BASE_URL + '/test/111/222',
      method: 'post',
    })
  },
}